import React from 'react';

function TimeInput(props: {
  id: string;
  label: string;
  extra?: string;
  variant?: string;
  state?: string;
  disabled?: boolean;
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}) {
  const {
    label,
    id,
    extra,
    variant,
    state,
    disabled,
    value,
    onChange,
  } = props;

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    let newValue = event.target.value;
    newValue = newValue.replace(/[^0-9:]/g, '');

    if (newValue.length === 2 && newValue.indexOf(':') === -1) {
      newValue += ':';
    }

    onChange({ ...event, target: { ...event.target, value: newValue } });
  };

  return (
    <div className={`${extra}`}>
      <label
        htmlFor={id}
        className={`text-sm text-navy-700 dark:text-white ${
          variant === "auth" ? "ml-1.5 font-medium" : "ml-3 font-bold"
        }`}
      >
        {label}
      </label>
      <input
        type="text"
        value={value}
        onChange={handleChange}
        disabled={disabled}
        id={id}
        placeholder="HH:MM"
        className={`mt-2 block w-full rounded-xl border bg-white/0 p-3 text-sm outline-none ${
          disabled === true
            ? "!border-none !bg-gray-100 dark:!bg-white/5 dark:placeholder:!text-[rgba(255,255,255,0.15)]"
            : state === "error"
            ? "border-red-500 text-red-500 placeholder:text-red-500 dark:!border-red-400 dark:!text-red-400 dark:placeholder:!text-red-400"
            : state === "success"
            ? "border-green-500 text-green-500 placeholder:text-green-500 dark:!border-green-400 dark:!text-green-400 dark:placeholder:!text-green-400"
            : "border-gray-200 dark:!border-white/10 dark:text-white"
        }`}
      />
    </div>
  );
}

export default TimeInput;
